import { plural } from './format';
import type { Messages } from './messages';

// DE: Deutsche Oberflächentexte.
// EN: German UI texts.
export const de: Messages = {
  tabToday: 'Heute',
  tabPlan: 'Plan',
  tabShopping: 'Einkauf',
  settings: 'Einstellungen',
  defaultMemberNames: ['Ich', 'Partner'],
  shoppingTitle: 'Einkauf',
  shoppingToday: 'Ja, heute geht es einkaufen',
  shoppingExtra: 'Heute noch nachkaufen',
  nothingToBuy: 'Heute muss nichts gekauft werden',
  shopsClosedToday: 'Heute sind die Geschäfte geschlossen',
  nextTrip: (date, stores, total) => `Nächster Einkauf: ${date} · ${stores} · ≈ ${total}`,
  itemCount: (count) => `${count} ${plural('de', count, { one: 'Produkt', other: 'Produkte' })}`,
  total: (total) => `Insgesamt ${total}`,
  totalWithWine: (total, wine) => `Insgesamt ${total}, davon Wein ${wine}`,
  openShoppingList: 'Einkaufsliste öffnen',
  amongShopping: 'Auf der Liste',
  dinnerTitle: 'Abendessen',
  minutes: (count) => `${count} Min.`,
  activeMinutes: (count) => `davon ${count} Min. am Herd`,
  portions: (count) =>
    `${count} ${plural('de', count, { one: 'Portion', other: 'Portionen' })}: Abendessen + Mittagessen zum Mitnehmen`,
  fish: 'Fisch',
  addOn: (member, product, amount) => `${member}: + ${product} ${amount}`,
  allAtHome: 'Alles schon da',
  recipe: 'Rezept',
  noEnergy: 'Keine Kraft',
  tomorrowTitle: 'Morgen',
  holidayTomorrow: (holiday) => `Morgen ist ${holiday}: Die Geschäfte sind geschlossen`,
  noPlanTitle: 'Noch kein Plan',
  planMonth: 'Plan bis Monatsende',
  planWeek: 'Plan für eine Woche',
  planEnds: (date) => `Der Plan endet am ${date}`,
  nextMonth: 'Plan für den nächsten Monat',
  nextWeek: 'Plan für die nächste Woche',
  planning: 'Plan wird erstellt …',
  chooseFederalState: 'Wähle in den Einstellungen dein Bundesland, damit Feiertage zählen.',
  close: 'Schließen',
  ingredients: 'Zutaten',
  steps: 'Zubereitung',
  noEnergyTitle: 'Etwas Schnelles stattdessen',
  noEnergyHint: 'Zuerst Gerichte aus dem, was zu Hause ist.',
  noAlternatives: 'Gerade gibt es keine schnellen Gerichte.',
  movedTo: (date) => `Das geplante Gericht ist jetzt am ${date}.`,
  useSoon: (products) => `Bitte bald verbrauchen: ${products}.`,
  planAgain: 'Neu planen',
  planAgainQuestion: 'Alle nicht fixierten Tage ab heute neu planen?',
  yes: 'Ja',
  cancel: 'Abbrechen',
  budgetPlanned: (planned, limit) => `Geplant ${planned} von ${limit}`,
  wholePlan: 'Ganzer Plan',
  thisWeek: 'Diese Woche',
  weekOf: (date, cost) => `Woche ab ${date} · ${cost}`,
  nextPlanTitle: 'Nächster Plan',
  quick: 'schnell',
  lunchbox: 'zum Mitnehmen',
  locked: 'fixiert',
  breakfast: 'Frühstück',
  lunch: 'Mittagessen',
  replace: 'Ersetzen',
  replaceTitle: 'Ersetzen durch',
  noReplacement: 'Für diesen Tag gibt es keine anderen Gerichte.',
  perPortion: (price) => `${price} pro Portion`,
  lock: 'Fixieren',
  unlock: 'Lösen',
  lowEnergyDay: 'An diesem Tag wenig Kraft',
  lowEnergyMarked: 'An diesem Tag ist etwas Schnelles geplant.',
  relaxedWarnings: {
    'relaxed-quick': 'Kein schnelles Gericht gefunden, daher ein längeres.',
    'relaxed-lunchbox': 'Das Gericht eignet sich nicht gut zum Mitnehmen.',
    'relaxed-variety': 'Das Gericht wiederholt sich früher als nach einer Woche.',
  },
  overBudget: (amount) => `Der Plan liegt ${amount} über dem Budget.`,
  checkAtHome: (products) => `Die Geschäfte sind zu. Ist das im Haus: ${products}?`,
  markBought: 'Eingekauft',
  doneTrips: 'Erledigte Einkäufe',
  allBought: 'Alle Einkäufe sind erledigt.',
  onOffer: 'Angebot',
  savings: (amount) => `Gespart: ${amount}`,
  categories: {
    veg: 'Obst & Gemüse',
    meat: 'Fleisch & Fisch',
    dairy: 'Milch & Eier',
    grain: 'Brot, Getreide, Nudeln',
    canned: 'Konserven',
    frozen: 'Tiefkühl',
    basics: 'Grundzutaten',
    drinks: 'Getränke',
  },
  languageTitle: 'Sprache',
  appearanceTitle: 'Darstellung',
  appearanceChoices: { system: 'Wie am Telefon', light: 'Hell', dark: 'Dunkel' },
  installHint:
    'Zum Home-Bildschirm hinzufügen: „Teilen“ → „Zum Home-Bildschirm“. So bleiben die Daten erhalten.',
  installHintDismiss: 'Verstanden',
  federalStateTitle: 'Bundesland',
  federalStateHint: 'Davon hängen die Feiertage ab, an denen die Geschäfte geschlossen sind.',
  notChosen: 'Nicht gewählt',
  closedDaysTitle: 'Eigene Ruhetage',
  closedDaysHint: 'Tage ohne Einkauf, zum Beispiel ein örtlicher Feiertag.',
  addClosedDay: 'Hinzufügen',
  remove: 'Entfernen',
  noClosedDays: 'Noch keine.',
  backupTitle: 'Sicherung',
  backupHint: 'Die Daten liegen nur auf diesem Telefon. Sichere sie in einer Datei.',
  downloadBackup: 'In Datei sichern',
  restoreBackup: 'Aus Datei wiederherstellen',
  restoreQuestion: 'Alle Daten auf diesem Telefon durch die Datei ersetzen?',
  restored: 'Daten wiederhergestellt.',
  backupErrors: {
    invalid: 'Die Datei ist keine Sicherung dieser App.',
    'newer-version':
      'Die Datei stammt aus einer neueren App-Version. Bitte zuerst die App aktualisieren.',
  },
  errorTitle: 'Etwas ist schiefgelaufen',
  errorText:
    'Die App kann die gespeicherten Daten nicht anzeigen. Sichere sie in einer Datei und starte dann neu: Eine Kopie bleibt auf dem Telefon.',
  errorSave: 'Daten sichern',
  errorRestart: 'Neu starten',
  holidays: {
    'new-year': 'Neujahr',
    epiphany: 'Heilige Drei Könige',
    'womens-day': 'Internationaler Frauentag',
    'good-friday': 'Karfreitag',
    'easter-monday': 'Ostermontag',
    'labour-day': 'Tag der Arbeit',
    ascension: 'Christi Himmelfahrt',
    'whit-monday': 'Pfingstmontag',
    'corpus-christi': 'Fronleichnam',
    assumption: 'Mariä Himmelfahrt',
    'world-childrens-day': 'Weltkindertag',
    'unity-day': 'Tag der Deutschen Einheit',
    'reformation-day': 'Reformationstag',
    'all-saints': 'Allerheiligen',
    'repentance-day': 'Buß- und Bettag',
    'christmas-day': '1. Weihnachtstag',
    'boxing-day': '2. Weihnachtstag',
  },
  states: {
    BW: 'Baden-Württemberg',
    BY: 'Bayern',
    BE: 'Berlin',
    BB: 'Brandenburg',
    HB: 'Bremen',
    HH: 'Hamburg',
    HE: 'Hessen',
    MV: 'Mecklenburg-Vorpommern',
    NI: 'Niedersachsen',
    NW: 'Nordrhein-Westfalen',
    RP: 'Rheinland-Pfalz',
    SL: 'Saarland',
    SN: 'Sachsen',
    ST: 'Sachsen-Anhalt',
    SH: 'Schleswig-Holstein',
    TH: 'Thüringen',
  },
};
